<template>
  <v-navigation-drawer
    v-model="drawer"
    dark
    color="baseColor"
    width="250"
    app
    clipped
  >
    <template v-slot:prepend>
      <v-list-item class="pointer" @click="viewUserProfile">
        <v-list-item-avatar>
          <v-img :src="$getProp($store.state, 'shell.userPicture')"></v-img>
        </v-list-item-avatar>
        <v-list-item-content class="text-left">
          <v-list-item-title>
            {{ $getProp($store.state, "shell.userFullName") }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <div class="caption">
              {{ $getProp($store.state, "shell.userEmail") }}
            </div>
            <div>
              <v-icon
                size="12"
                class="mr-1"
                v-text="$getIcon('mdiShieldAccount')"
              ></v-icon>
              <span class="caption">
                {{ $getProp($store.state, "shell.userOrganizationName") }}
              </span>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <drawer-items :drawer-items="normalUserItems" :key="selectedOrganization"></drawer-items>
    <v-divider></v-divider>
  </v-navigation-drawer>
</template>

<script>
import DrawerItems from "./Common/layout-utils/DrawerItems";

export default {
  components: { DrawerItems },
  props: {
    drawer: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      normalUserItems: []
    };
  },
  computed: {
    selectedOrganization() {
      return this.$store.state.shell.currentOrganizationId
    }
  },
  created() {
    this.setSidebar();
  },
  methods: {
    setSidebar() {
      this.normalUserItems = this.$shellOptions.sidebarItems;
      // this.normalUserItems = this.getActiveNavItems(normalUserItems);
    },
    viewUserProfile() {
      // todo @wrufesh goto user profile url
    }
    // getActiveNavItems(menu) {
    //   if (!this.$route.name) return menu;
    //   const routeName = this.$route.name;
    //   const menuIndex = menu.findIndex(x => {
    //     if (x.children && x.children.length > 0) {
    //       const y = Object.values(x.children).find(y => {
    //         if (y.to && routeName.includes(y.to.name)) return true;
    //       });
    //       if (y) return true;
    //     } else {
    //       return routeName.includes(x.to.name);
    //     }
    //   });
    //   menu.map(x => {
    //     x.active = false;
    //   });
    //   if (menuIndex !== -1) {
    //     menu[menuIndex].active = true;
    //   }
    //   return menu;
    // }
  }
};
</script>
<style>
.abbChip {
  padding: 0 6px !important;
}
.v-navigation-drawer__content {
  scrollbar-width: none !important;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 0 !important;
}
.active-nav-item {
  border-left: 4px solid #56a8fe;
}
</style>
